import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

const checkListReducer = (state = initialState.document.checklist, action) => {
  switch (action.type) {
    case actionTypes.LOAD_CHECKLIST_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_CHECKLIST_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    case eventTypes.CHECKLIST_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: false
        }
      };
    }

    default:
      return state;
  }
};

export default checkListReducer;
